export enum ProductGroupType {
    PRODUCT = 'PRODUCT',
    SUBSCRIPTION = 'SUBSCRIPTION',
    EVENT_TICKET = 'EVENT_TICKET'
}
